import { Button } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDefineUserRole } from '../../../hooks';

const ButtonAddProduct: React.FC = () => {
  const intl = useIntl();
  const { me } = useSelector(({ profile }: any) => profile);
  const navigate = useNavigate();

  const goToCreateProduct = useCallback(() => {
      navigate(`/products/create`);
  }, [navigate]);

  return (
    <>
      <Button color='primary' variant='contained' onClick={goToCreateProduct}>
        {intl.formatMessage({ id: 'CATEGORY.BUTTON.ADD.PRODUCT' })}
      </Button>
    </>
  );
};

export default ButtonAddProduct;
